/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @returns {*}
 * @constructor
 */
export const InnovationGraphKnobs = ({
                                       cardIndex,
                                       endpointQuery,
                                       widgetConfiguration,
                                     }) => {
  return (
    <React.Fragment>
    </React.Fragment>
  );
};
